import React, { useState, memo, useCallback } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { MenuVerticalIcon } from '~/assets/icons';
import styles from './CRMStatusList.module.scss';
import classNames from 'classnames/bind';
import { BaseSort } from '~/components/common';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import MenuOption from '~/components/crm-status/menu-option/MenuOption';
import { useTranslation } from 'react-i18next';
import usePermission from '~/hooks/usePermission';
import { PERMISSIONS } from '~/utils/constants/permission';
import { ICRMStatus } from '~/utils/interface/crm-status';
import { crmStatusActions } from '~/thunks/crm-status/crmStatusSlice';
import dayjs from 'dayjs';
import { Checkbox } from '@mui/material';
import { handleUpdateposition } from '~/thunks/crm-status/crmStatusThunk';
const cx = classNames.bind(styles);

type CRMStatusListProps = {
  data?: ICRMStatus;
  onOpenEdit: (id: string) => void;
};

function CRMStatusList(props: CRMStatusListProps) {
  const permissions = usePermission();
  const { t } = useTranslation(['admin/crm-status']);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [anchorElSort, setAnchorElSort] = useState<null | HTMLElement>(null);
  const [selected, setSelected] = useState<string[]>([]);
  const isSelected = (id: string) => selected.indexOf(id) !== -1;

  const [selectAll, setSelectAll] = useState(false);
  // const [selectedProperty, setSelectedProperty] = useState<string | null>(null);

  const [menuSelectedId, setMenuSelectedId] = useState<string | undefined>(undefined);
  const { crmStatuses } = useAppSelector((state) => state.crmStatus);
  const dispatch = useAppDispatch();

  const openOptionMenu = (event: React.MouseEvent<HTMLButtonElement>, itemId: string) => {
    dispatch(crmStatusActions.changeCRMStatusId(itemId));
    setAnchorEl(event.currentTarget);
    setMenuSelectedId(itemId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuSelectedId(undefined);
  };

  // const handleCloseSort = () => {
  //   setAnchorElSort(null);
  // };

  const setSelectedIds = useCallback(
    (selected: Array<string>) => {
      dispatch(crmStatusActions.changeSelectedIds(selected));
    },
    [dispatch]
  );

  const handleEditItem = async () => {
    handleClose();
    if (menuSelectedId !== undefined) {
      props.onOpenEdit(menuSelectedId);
    }
  };

  const handleDeleteItem = () => {
    handleClose();
    if (menuSelectedId !== undefined) {
      dispatch(crmStatusActions.changeMenuSelectId(menuSelectedId));
      dispatch(crmStatusActions.changeOpenAlertDelete(true));
    }
  };

  // const handleChangePage = (event: unknown, newPage: number) => {
  //   dispatch(
  //     crmStatusActions.setFilter({
  //       page: newPage,
  //     })
  //   );
  // };

  // const handleRequestSort = (sortBy: Array<{ orderBy: string; order: SortDirection }>) => {
  //   dispatch(
  //     crmStatusActions.setFilter({
  //       sort: sortBy.map((item) => ({
  //         field: item.orderBy,
  //         type: item.order,
  //       })),
  //     })
  //   );
  // };

  const handleClick = (event: React.ChangeEvent<unknown>, id: string) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelectAll(crmStatuses.length === newSelected.length);
    setSelected(newSelected);
    setSelectedIds(newSelected);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelected(crmStatuses.map((item) => item.id));
      setSelectedIds(crmStatuses.map((item) => item.id));
    } else {
      setSelected([]);
      setSelectedIds([]);
    }
  };

  // const renderActiveSort = () => {
  //   return filter?.sort?.find((item) => item.field === selectedProperty)?.type;
  // };

  // const createSortHandler = (sortDirection: SortDirection) => {
  //   if (selectedProperty) {
  //     handleRequestSort([{ orderBy: selectedProperty, order: sortDirection }]);
  //   }
  //   handleCloseSort();
  // };

  // const openSortDirectionMenu = (property: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setAnchorElSort(event.currentTarget);
  //   setSelectedProperty(property);
  // };

  const handleItemChange = async (item: any) => {
    await dispatch(handleUpdateposition({ id: item.$id, params: { position: item.position } })).unwrap();
    dispatch(crmStatusActions.changeNeedRefreshData(true));
  };

  return (
    <Box className={cx('equipment-list-container')}>
      <Box className={'flex justify-between items-center gap-[20px] my-3 w-full bg-[#ffffff]'}>
        <Box className={'w-[10px]'}></Box>
        <Box className='gap-[30px] w-full flex items-center'>
          <Box className='flex-[0_0_2%]'>
            <Checkbox className='w-[20px] h-[20px]' color='primary' checked={selectAll} onChange={handleSelectAll} />
          </Box>
          <Box className='flex-[0_0_45%] text-[16px]/[24px] font-[500] text-[#0d062d]'>{t('properties.name')}</Box>
          <Box className='flex-[0_0_45%] text-[16px]/[24px] font-[500] text-[#0d062d]'>{t('properties.createdAt')}</Box>
          <Box className='flex-[0_0_3%]'>
            <IconButton onClick={(event) => {}}>
              <MenuVerticalIcon className='w-[19px] h-[19px] invisible' />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <BaseSort
        onItemChange={handleItemChange}
        data={crmStatuses}
        search={() => true}
        render={(data, index, onItemChange) => {
          return (
            <Box className={'flex justify-between items-center gap-[20px] my-3 w-full bg-[#ffffff] '} key={index}>
              <Box className='gap-[30px] w-full flex items-center'>
                <Box className='flex-[0_0_2%]'>
                  <Checkbox
                    className='w-[20px] h-[20px]'
                    color='primary'
                    onChange={(event) => {
                      handleClick(event, data.id);
                    }}
                    checked={isSelected(data.id)}
                  />
                </Box>

                <Box className='flex-[0_0_45%] font-[500] '>{data.name}</Box>

                <Box className='flex-[0_0_45%] font-[500]'>{dayjs(data.createdAt).format('MMM DD, YYYY')}</Box>
                {(permissions[PERMISSIONS.crmStatusSetting_delete] ||
                  permissions[PERMISSIONS.crmStatusSetting_edit] ||
                  permissions[PERMISSIONS.crmStatusSetting_view]) && (
                  <Box className='flex-[0_0_3%]'>
                    <IconButton
                      onClick={(event) => {
                        openOptionMenu(event, data.id);
                      }}
                    >
                      <MenuVerticalIcon className='w-[19px] h-[19px]' />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Box>
          );
        }}
      />
      {/* <Box className={cx('table-pagination-container')}>
        <BasePagination count={totalPages} page={currentPage} onChange={handleChangePage} />
      </Box> */}
      <MenuOption
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        handleEditItem={handleEditItem}
        handleDeleteItem={handleDeleteItem}
      />
      {/* <MenuSortDirection
        anchorEl={anchorElSort}
        open={Boolean(anchorElSort)}
        onClose={handleCloseSort}
        active={renderActiveSort()}
        onSelectAscDirection={() => createSortHandler('ASC')}
        onSelectDescDirection={() => createSortHandler('DESC')}
      /> */}
    </Box>
  );
}

export default memo(CRMStatusList);
